import { render, staticRenderFns } from "./ComplaintEmisorForm.vue?vue&type=template&id=c3aec76a&scoped=true"
import script from "./ComplaintEmisorForm.vue?vue&type=script&lang=js"
export * from "./ComplaintEmisorForm.vue?vue&type=script&lang=js"
import style0 from "./ComplaintEmisorForm.vue?vue&type=style&index=0&id=c3aec76a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3aec76a",
  null
  
)

export default component.exports